/* global globalThis */
import { httpsCallable } from 'firebase/functions';
import { functions } from '@/firebaseConfig';

const request = httpsCallable(functions, 'sendTechnicalTicketMessage', { timeout: 60000 });

export function createTechnicalMessageId() {
  return globalThis.crypto?.randomUUID?.()
    || `message-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export async function sendTechnicalTicketMessage({ ticketId, content, messageId = createTechnicalMessageId() }) {
  const result = await request({ ticketId, content, messageId });
  return result.data;
}

export async function createTechnicalTicket({ userId, title = '', content, messageId = createTechnicalMessageId() }) {
  const result = await request({ create: true, userId, title, content, messageId });
  return result.data;
}
